import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import { GET_DASHBOARD, RESET_DASHBOARD } from 'containers/dashboard/constants';

const statusTotal = new schema.Entity('statusTotal', undefined, { idAttribute: 'key' });
const accountTotal = new schema.Entity('accountTotal');
const costCenterTotal = new schema.Entity('costCenterTotal');
const costCenterTotalAmount = new schema.Entity('costCenterTotalAmount');

const dashboardSchema = {
  totalByAccount: [accountTotal],
  totalByCostCenter: [costCenterTotal],
  amountByCostCenter: [costCenterTotalAmount],
  totalByStatus: [statusTotal],
};

export const getPending = (state) => ({
  ...state,
  loading: true,
  loaded: false,
});

export const getRejected = (state) => ({
  ...state,
  loading: true,
  loaded: false,
  entities: {},
  result: {},
});

export const getFulfilled = (state, { payload }) => {
  const pick = ({ totalByAccount, totalByCostCenter, amountByCostCenter, totalByStatus }) => ({
    totalByAccount,
    totalByCostCenter,
    amountByCostCenter,
    totalByStatus,
  });

  const n = normalize(pick(payload), dashboardSchema);

  return {
    ...state,
    loading: false,
    loaded: true,
    ...n,
    result: {
      ...n.result,
      assetsSummary: (payload && payload.assetsSummary) || {},
    },
  };
};

export const initialState = {
  loaded: false,
  loading: false,
};

export const reset = (state) => ({ ...initialState });

const dashboardReducers = {
  [GET_DASHBOARD]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
  [RESET_DASHBOARD]: reset,
};

export default TypeToReducer(dashboardReducers, initialState);



// WEBPACK FOOTER //
// src/containers/dashboard/reducers.js